module.exports = __webpack_public_path__ + "img/071-woman.f01caee5.png";